import type { Construct } from './construct.interface';

export interface cv_ConstructStatus {
    Abbreviation: string;
    C_ConstructStatus_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    Construct: Construct[];
    ConstructStatus: string;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsEndStatus: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
